import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import InputAdornment from '@material-ui/core/InputAdornment';
import Popup from 'reactjs-popup';
import { specimenLocationItems } from '../../constants';
import CaseSpecimen2dProstate from '../../components/specimen/CaseSpecimen2dProstate';
import UploadComponent from './UploadComponent';
import Modal2dProstate from '../../components/modals/Modal2dProstate';



const SpecimenTableComponent = ({
  specimens,
  handleChange,
  handleDelete,
  handleImageUploaded,
  handleImageDelete,
  handlePlot,
  canEdit,
  canUploadImage,
}
) => {
  const rowStyle = { display: 'flex', flexDirection: 'row', margin: 'auto', justifyContent: 'space-evenly', width: '100%' };
  return (
    <Paper className="form-part-one-specimen-submitted">
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Specimen ID</TableCell>
            <TableCell colSpan={3}>Location from which taken</TableCell>
            <TableCell align="left">Plot location</TableCell>
            <TableCell>Number of cores</TableCell>
            <TableCell colSpan={2}>Length of core(s)</TableCell>
            <TableCell>Tissue image</TableCell>
            <TableCell style={{ visibility: canEdit ? 'visible' : 'hidden' }}>Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {specimens.map((specimen, index) => (
            <TableRow
              key={specimen._id}
              className="specimen-table-row"
            >
              <TableCell>{specimen.id}</TableCell>

              <TableCell key="LOCATION_TAKEN" colSpan={3}>
                <Select
                  disabled={!canEdit}
                  style={{ minWidth: '230px', fontWeight: 350 }}
                  value={specimen.specimenLocation}
                  onChange={(e) => handleChange(e, specimen._id, 'specimenLocation')}
                  MenuProps={{
                    anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
                    transformOrigin: { vertical: 'top', horizontal: 'left' },
                    getContentAnchorEl: null,
                  }}
                  autoWidth
                >
                  {specimenLocationItems.map((location, index) => (
                    <MenuItem style={{fontSize: 'small'}} key={location} value={index}>{location}</MenuItem>
                  ))}
                </Select>
              </TableCell>
              <TableCell key="PLOT_LOCATION" align="left">

                {canEdit ? (
                    <Modal2dProstate
                      handlePlot={handlePlot}
                      specimenLocation={specimen.specimenLocation}
                      selected={specimen.id}
                      coords={specimen.coordinates}
                      editable
                      thumbnail={false}
                    />

                ) : (
                    <Popup
                      trigger={<div className="btn--prostate has-plot-location" />}
                      position="top center"
                      on="hover"
                    >
                      <CaseSpecimen2dProstate
                        specimenLocation={specimen.specimenLocation}
                        selected={specimen.id}
                        coords={specimen.coordinates}
                        editable={false}
                        thumbnail
                      />
                    </Popup>
                  )}


              </TableCell>
              <TableCell key="NR_OF_CORES">
                <TextField
                  type="number"
                  disabled={!canEdit}
                  inputProps={{ min: '0', max: '9' }}
                  onChange={(e) => handleChange(e, specimen._id, 'totalNumberOfCores')}
                  defaultValue={specimen.totalNumberOfCores}
                />
              </TableCell>
              <TableCell key="LENGTH_OF_CORES" colSpan={2}>
                <div style={{ ...rowStyle, alignItems: 'flex-end', minWidth: '70px' }}>
                  <TextField
                    type="number"
                    inputProps={{
                      min: '0',
                      step: '1',
                    }}
                    disabled={!canEdit}
                    onChange={(e) => handleChange(e, specimen._id, 'lengthOfCores')}
                    defaultValue={specimen.lengthOfCores}
                    InputProps={{
                      endAdornment: <InputAdornment position="end">mm</InputAdornment>,
                    }}
                  />

                </div>
              </TableCell>
              <TableCell align="center" key="TISSUE_IMAGE">
                {specimen.cadessId.length ? (
                  <div style={rowStyle}>
                    <Popup
                      trigger={<div style={{ width: '30px', height: '30px', verticalAlign: 'baseline' }}
                        className="custom-file-upload has-upload" />}
                      position="top center"
                      on="hover"
                    >
                      <img
                        style={{ display: 'block', width: 'auto', margin: '0 auto', height: '100px' }}
                        alt="thumbnail"
                        src={specimen.thumbnail}
                      />
                    </Popup>
                    {canUploadImage && (
                      <button
                        type="button"
                        disabled={!canUploadImage}
                        className="btn--trash-icon"
                        style={{ width: '30px', height: '30px', verticalAlign: 'baseline' }}
                        onClick={() => handleImageDelete(specimen)}
                      />
                    )}
                  </div>
                ) : <UploadComponent disabled={!canUploadImage} specimen={specimen} handleImageUploaded={handleImageUploaded} />}

              </TableCell>
              <TableCell key="SPECIMEN" style={{ visibility: canEdit ? 'visible' : 'hidden' }}>
                <button disabled={!canEdit} type="button" className="btn--trash-icon" onClick={() => handleDelete(specimen)} />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  );
};

export default SpecimenTableComponent;
